// Shared Messenger session helpers (issue #423 follow-up).
//
// `readSession` and the admin role set were previously copy-pasted across
// `index.tsx`, `SupportInbox.tsx`, and `JobChatPanel.tsx`. The support
// internal-note composer (`SupportThreadComposer`) and `ChatPaneV2` both need
// the same admin gate, so the canonical version lives here. New consumers
// import from this module rather than re-declaring the localStorage parse.

export const ADMIN_ROLE_NAMES = new Set([
  'ADMIN',
  'COMPANY_ADMIN',
  'SUPER_ADMIN',
  'LABOR_COORDINATOR'
]);

export interface MessengerSession {
  id: number;
  roleName?: string;
}

export function readSession(): MessengerSession | undefined {
  try {
    const raw = localStorage.getItem('PLS');
    if (!raw) return undefined;
    const parsed = JSON.parse(raw);
    const user = parsed?.user ?? parsed?.principal ?? parsed;
    const id = Number(user?.id);
    if (!Number.isFinite(id)) return undefined;
    const roleName = (user?.Role?.name ?? user?.role) as string | undefined;
    return { id, roleName };
  } catch {
    return undefined;
  }
}

export function isAdminRole(roleName: string | undefined): boolean {
  return !!(roleName && ADMIN_ROLE_NAMES.has(roleName));
}
